<div class="field col-12">
    <label>{{pergunta.detalhesTitulo}}</label>
    <p-dropdown [options]="pergunta.detalhesOpcoes" appendTo="body" [autoDisplayFirst]="false"
        [(ngModel)]="pergunta.resposta" [disabled]="!habilitado" (ngModelChange)="respostaAlterada()"></p-dropdown>
</div>